export const apiKey = 'a50c252cc8f85f81672566f5b53a8438';
export const apiUrl = 'https://api.openweathermap.org/data/2.5/';
